var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCfxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9525 8.64784C12.6649 11.8387 9.42367 14.9828 6 18.317C6 16.6765 6 15.2995 6 13.9225C6.03149 13.7075 6.13717 13.5104 6.29858 13.3657C9.51325 10.2516 12.7146 7.17414 15.9791 4C17.0672 5.03026 18.1587 6.03718 19.2236 7.06744C21.2871 9.06795 23.3274 11.1018 25.4041 13.0923C25.6087 13.2722 25.7686 13.4976 25.8711 13.7505C25.9736 14.0035 26.0159 14.277 25.9947 14.5493C25.9548 15.733 25.9947 16.9199 25.9947 18.3636L15.9525 8.64784Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36365 20.6231L16.0052 13.2727L18.1691 15.5618L13.3708 20.6033C14.2125 21.4898 15.0972 22.426 16.1908 23.5805C17.8046 21.7148 19.3654 19.902 20.9295 18.0892L21.4133 18.2843L23.4546 20.8547L16.0549 28L8.36365 20.6231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfxWhite);
export default __webpack_public_path__ + "static/media/cfx-white.7767e6be4f30224371f05a4da61169cc.svg";
export { ForwardRef as ReactComponent };